import React from 'react'

const Eva = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53 0C87.7469 0 102.001 17.4742 102 31C101.999 44.5258 82.4108 48 53 48C23.9528 48 2 44.5258 2 31C2 17.4742 17.1142 0 53 0Z"
        fill="black"
        fillOpacity="0.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8179 34.654C22.2912 33.3001 17.5833 28.3121 18.3026 23.513C19.0218 18.7139 24.8959 15.9211 31.4226 17.275C37.9493 18.629 42.6572 23.617 41.9379 28.416C41.2187 33.2151 35.3446 36.0079 28.8179 34.654Z"
        fill="#25A6F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.4226 34.654C68.8959 36.0079 63.0218 33.2151 62.3026 28.416C61.5833 23.617 66.2912 18.629 72.8179 17.275C79.3446 15.9211 85.2187 18.7139 85.9379 23.513C86.6572 28.3121 81.9493 33.3001 75.4226 34.654Z"
        fill="#25A6F5"
      />
    </>
  )
}
export default Eva
